export const common = {
  login: 'Login',
  register: 'Register',
  logout: 'Logout',
  confirm: 'Confirm',
  cancel: 'Cancel',
  submit: 'Submit',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  search: 'Search',
  loading: 'Loading...',
  retry: 'Retry',
  noData: 'No data',
  error: 'Error occurred',
  success: 'Success',
  back: 'Back',
  next: 'Next',
  prev: 'Previous',
  done: 'Done',
  more: 'More',
  all: 'All',
  today: 'Today',
  yesterday: 'Yesterday',
  week: 'This Week',
  month: 'This Month',
  year: 'This Year',
  home: 'Home',
  market: 'Market',
  lockPrice: 'Lock Price',
  orders: 'Orders',
  profile: 'Profile',
  language: 'Language',
  zhCN: 'Simplified Chinese',
  en: 'English',
  zhTW: 'Traditional Chinese',
  serviceTerms: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  riskWarning: 'Risk Warning',
  phone: 'Phone Number',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  forgotPassword: 'Forgot Password?',
  noAccount: "Don't have an account?",
  hasAccount: 'Already have an account?',
  registerNow: 'Register Now',
  loginNow: 'Login Now',
  placeholderPhone: 'Enter phone number',
  placeholderPassword: 'Enter password',
  errorPhoneEmpty: 'Please enter phone number',
  errorPhoneFormat: 'Please enter a valid 11-digit phone number',
  errorPasswordEmpty: 'Please enter password',
  errorPasswordLength: 'Password must be at least 6 characters',
  errorPasswordMismatch: 'Passwords do not match',
  errorAgreeTerms: 'Please agree to the user agreement',
  errorInvalidCredentials: 'Incorrect phone or password, please try again',
  errorEmailNotConfirmed: 'Account not verified, please contact admin',
  errorLoginFailed: 'Login failed: {{message}}',
  errorAccountExists: 'This phone is already registered, please login directly',
  errorRateLimit: 'Too many registration attempts, please try again in about 1 hour',
  errorRegisterFailed: 'Registration failed: {{message}} (code: {{code}}, status: {{status}})',
  errorRegisterSuccessNoLogin: 'Registration succeeded but auto-login failed, please login manually',
  loginSuccess: 'Login successful',
  registerSuccess: 'Registration successful',
  welcomeLogin: 'Welcome Back',
  welcomeRegister: 'Create Account',
  registerSubtitle: 'Start your gold investment journey',
  agreeTerms: 'I have read and agree to',
  userAgreement: 'User Service Agreement',
  privacyPolicyDoc: 'Privacy Policy',
  resetPasswordHint: 'Please contact customer service to reset password',
  confirmLogout: 'Confirm logout?',
  userServiceAgreement: 'User Service Agreement',
  ok: 'OK',
  close: 'Close',
  copy: 'Copy',
  copied: 'Copied',
  amount: 'Amount',
  date: 'Date',
  status: 'Status',
  detail: 'Detail',
  notice: 'Notice',
  viewAll: 'View All',
  latestNotice: 'Latest Notice',
  noNotice: 'No notices',
  noticeLoadFailed: 'Failed to load notices',
  contactCustomerService: 'Please contact customer service to reset password',
  settings: 'Settings',
  accountSecurity: 'Account & Security',
  notifications: 'Notifications',
  general: 'General',
  changePassword: 'Change Password',
  changePhone: 'Change Phone',
  realNameVerify: 'Real Name Verification',
  verified: 'Verified',
  verifyThenChange: 'Please verify with SMS before changing',
  priceAlert: 'Price Alerts',
  priceAlertDesc: 'Notify when price fluctuates significantly',
  tradeAlert: 'Trade Alerts',
  tradeAlertDesc: 'Lock, payment, delivery updates',
  systemPush: 'System Push',
  systemPushDesc: 'Announcements and events',
  clearCache: 'Clear Cache',
  cacheCleared: 'Cache cleared',
  about: 'About',
};